import React from 'react';
import {useDispatch} from "react-redux";

import {IconComponent} from "../../reusable/simpleComponents";
import {setOpenedCameraList} from "../../../store/cameras/actions";


const CameraListUIComponent = () => {
    const dispatch = useDispatch();

    const handler = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        dispatch(setOpenedCameraList(true))
    };

    return <IconComponent
        classValue="cameralist-icon pointer"
        handler={ handler }
        title="Select Camera"
    />
};

export default CameraListUIComponent